var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from '@/hooks/lib/react-router/useNavigate';
import { POPUP_TYPE_PROFFIT_SEARCH_FIRST_VIEW } from '@/utils/constants/popup/eventType';
import { usePopupEvent } from '../../user/usePopupEvent';
/**
 * チュートリアルの表示を制御するuse
 * @param dispatch
 * @param isFree
 * @returns {{isShowSearchFirstView: (boolean|boolean), finishOnBoarding: ((function(): Promise<void>)|*)}}
 */
export const useSlideSearchTutorial = (dispatch, isFree) => {
    const history = useNavigate();
    const profile = useSelector((state) => state.profile);
    const popups = useSelector((state) => state.popup);
    const receive = useSelector((state) => state.proffitSearchReceiveHeader);
    /** Driver 表示対象の Ref */
    const driverTargetRef = useRef(null);
    /** Driver から情報を受け取る用の Ref */
    const driverRef = useRef(null);
    /** Driver から情報を受け取る用の State */
    const [driverState, changeDriverState] = useState(null);
    // 初回チュートリアル完了フラグ更新
    const eventFirstView = usePopupEvent(dispatch, POPUP_TYPE_PROFFIT_SEARCH_FIRST_VIEW);
    // 初回チュートリアル完了フラグ
    const isShowSearchFirstView = useMemo(() => {
        const { viewPopups } = profile || {};
        return popups.accessEvent[POPUP_TYPE_PROFFIT_SEARCH_FIRST_VIEW]
            ? false
            : (viewPopups || []).includes(POPUP_TYPE_PROFFIT_SEARCH_FIRST_VIEW);
    }, [profile, popups.accessEvent]);
    /** Driver の対象がアクティブかどうか */
    const isActiveDriverTarget = useMemo(() => (driverState === null || driverState === void 0 ? void 0 : driverState.isShow) && (driverState === null || driverState === void 0 ? void 0 : driverState.activeIndex) === 0, [driverState]);
    /**
     * Driver オーバーレイクリック時イベント
     */
    const onClickDriverOverlay = useCallback(() => {
        var _a, _b;
        (_b = (_a = driverRef.current) === null || _a === void 0 ? void 0 : _a.stop) === null || _b === void 0 ? void 0 : _b.call(_a);
    }, [driverRef]);
    /**
     * 対象クリック時に Driver 非表示
     */
    const onClickDriverTarget = useCallback(() => {
        var _a, _b;
        if (isActiveDriverTarget) {
            (_b = (_a = driverRef.current) === null || _a === void 0 ? void 0 : _a.stop) === null || _b === void 0 ? void 0 : _b.call(_a);
        }
    }, [driverRef, isActiveDriverTarget]);
    /**
     * Driver の表示
     */
    const showOnBoarding = useCallback(() => {
        var _a, _b;
        (_b = (_a = driverRef.current) === null || _a === void 0 ? void 0 : _a.start) === null || _b === void 0 ? void 0 : _b.call(_a);
    }, [driverRef]);
    /**
     * チュートリアルの完了処理
     * @type {(function(): Promise<void>)|*}
     */
    const finishOnBoarding = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        // チュートリアル表示フラグ更新
        eventFirstView();
        // フリープランの場合アップロード不可なので、コーチマークを表示させない
        if (isFree) {
            // 未読の受領スライドがある場合、受領一覧に一覧に飛ばす
            if (receive.unreadCount > 0) {
                history.push('/proffit_search/receive_folder');
            }
            return;
        }
        // コーチマーク（Driver）を表示（input指定がない場合は表示しない）
        if (driverTargetRef && driverTargetRef.current) {
            showOnBoarding();
        }
    }), [
        history,
        eventFirstView,
        driverTargetRef,
        isFree,
        receive,
        showOnBoarding,
    ]);
    return {
        changeDriverState,
        driverRef,
        driverTargetRef,
        finishOnBoarding,
        isActiveDriverTarget,
        isShowSearchFirstView,
        onClickDriverOverlay,
        onClickDriverTarget,
    };
};
export default useSlideSearchTutorial;
